import { AuthErrorCodes } from 'firebase/auth';
import { FirebaseAuthError } from './interface';

const FIREBASE_LOCALIZED_ERROR_MAP = new Map<string, string>([
  [
    AuthErrorCodes.INVALID_PASSWORD,
    "We couldn't find an account with that email address and password. Please double-check and try again.",
  ],
  [
    AuthErrorCodes.USER_DELETED,
    "We couldn't find an account with that email address or password. Please double-check and try again.",
  ],
  [
    AuthErrorCodes.TOO_MANY_ATTEMPTS_TRY_LATER,
    'Too many login attempts. Please try again later or reset your password.',
  ],
  [AuthErrorCodes.TOKEN_EXPIRED, 'Authentication token has expired. Please try again.'],
]);

export function localizeError(error: Record<string, any> & { code: string }) {
  // try to get error by code
  let localizedError = FIREBASE_LOCALIZED_ERROR_MAP.get(error.code);

  // if not found, try to get error by code inside the message
  if (!localizedError) {
    const customMessage = error.customData?.message ?? '';

    FIREBASE_LOCALIZED_ERROR_MAP.forEach((value, key) => {
      if (customMessage.includes(key)) {
        localizedError = value;
      }
    });
  }

  if (localizedError) {
    return new FirebaseAuthError(localizedError, error.code);
  }

  return error;
}
